module.exports = "<div class=modal-header> <h3 class=\"modal-title text-center\" id=myModalLabel>{{object.title}}</h3> </div> <div class=\"modal-body text-center\"> <h4> {{object.message}} </h4> <br/> <div> <h5> {{object.detail}} </h5> </div> </div> <div class=\"modal-footer clear\"> <a class=\"btn btn-default\" ng-click=cancel()> <i class=\"fa fa-reply\"></i> {{ 'utils_notify.retry' | translate }} </a> <a class=\"btn btn-warning\" ng-click=delete()> <i class=\"fa fa-trash-o\"></i> {{ 'utils_notify.delete' | translate }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/NotifyDelete.html
// module id = 446
// module chunks = 0